export default __webpack_public_path__ + "static/media/onboardingLogo.392ca32c.png";